import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useBrand } from '../../contexts/BrandContext';
import BrandLogo from '../BrandLogo';
import axios from 'axios';
import { TrendingUp } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = ({ language }) => {
  const { tt } = useLanguage();
  const { brandName } = useBrand();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    axios.get(`${API}/brand/partners`).then(r => {
      setPartners(Array.isArray(r.data) ? r.data : []);
    }).catch(() => setPartners([]));
  }, []);
  const translations = {
    ru: {
      company: brandName,
      disclaimer: 'Эта онлайн-платформа предоставляет широкую информацию, не принимая во внимание особые требования эмитента или особое финансовое положение. Вам необходимо ознакомиться с Правилами и Условиями перед взаимодействием с нашей организацией, чтобы убедиться, что условия дальнейшего сотрудничества удовлетворяют вашим требованиям. Инвестиционные потери возможны при торговле на финансовых рынках; в нашем заявлении о раскрытии рисков содержится дополнительная информация.',
      partners: 'Наши партнеры:',
      registrationNumber: 'Регистрационный номер компании CRD: 23551',
      rulesAndConditions: 'Правила и Условия',
      riskDisclosure: 'заявлении о раскрытии рисков'
    },
    en: {
      company: brandName,
      disclaimer: 'This online platform provides broad information, without taking into account special issuer requirements or special financial circumstances. You need to familiarize yourself with the Rules and Conditions before interacting with our organization, to ensure that the terms of further cooperation meet your requirements. Investment losses are possible when trading on financial markets; our risk disclosure statement contains additional information.',
      partners: 'Our Partners:',
      registrationNumber: 'Company Registration Number CRD: 23551',
      rulesAndConditions: 'Rules and Conditions',
      riskDisclosure: 'risk disclosure statement'
    },
    kk: {
      company: brandName,
      disclaimer: 'Бұл онлайн-платформа эмитенттің ерекше талаптарын немесе ерекше қаржылық жағдайын ескермей, кең ақпарат береді. Одан әрі ынтымақтастық шарттары сіздің талаптарыңызға сай келетініне көз жеткізу үшін ұйымымызбен әрекеттесу алдында Ережелер мен Шарттармен танысуыңыз керек. Қаржы нарықтарында саудалау кезінде инвестициялық шығындар мүмкін; біздің тәуекелдерді ашу туралы мәлімдемеде қосымша ақпарат бар.',
      partners: 'Біздің серіктестер:',
      registrationNumber: 'Компания тіркеу нөмірі CRD: 23551',
      rulesAndConditions: 'Ережелер мен Шарттар',
      riskDisclosure: 'тәуекелдерді ашу туралы мәлімдеме'
    }
  };

  const t = translations[language] || translations['ru'];

  // Partners section now uses direct HTML instead of array

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-green-900 to-emerald-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Company Logo */}
        <div className="flex items-center justify-center mb-8">
          <BrandLogo size="lg" />
        </div>

        {/* Disclaimer Section */}
        <div className="bg-black/20 backdrop-blur-sm rounded-2xl p-8 mb-8 border border-white/10">
          <p className="text-gray-300 leading-relaxed text-center max-w-5xl mx-auto">
            {t.disclaimer.split('Правилами и Условиями').length > 1 ? (
              <>
                {t.disclaimer.split('Правилами и Условиями')[0]}
                <a href="#" className="text-emerald-400 font-semibold hover:text-emerald-300 transition-colors">
                  {t.rulesAndConditions}
                </a>
                {t.disclaimer.split('Правилами и Условиями')[1].split('заявлении о раскрытии рисков')[0]}
                <a href="#" className="text-emerald-400 font-semibold hover:text-emerald-300 transition-colors">
                  {t.riskDisclosure}
                </a>
                {t.disclaimer.split('заявлении о раскрытии рисков')[1]}
              </>
            ) : (
              t.disclaimer
            )}
          </p>
        </div>

        {/* Partners Section - dynamically loaded from /api/brand/partners */}
        {partners.length > 0 && (
          <div className="text-center mb-12" data-testid="footer-partners">
            <h3 className="text-2xl font-bold mb-8 text-white">
              {t.partners}
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
              {partners.map((p) => (
                <div
                  key={p.id}
                  className="flex items-center justify-center bg-white rounded-xl p-4 h-20"
                  title={p.name}
                  data-testid={`footer-partner-${p.id}`}
                >
                  {p.logo_url ? (
                    <img
                      src={p.logo_url}
                      alt={p.name}
                      className="max-h-14 max-w-full object-contain"
                    />
                  ) : (
                    <span className="text-sm font-bold text-gray-800">{p.name}</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Registration Number */}
        <div className="text-center">
          <p className="text-emerald-400 font-semibold">
            {t.registrationNumber}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;